import type { IconProps } from '../types/IconProps.ts';
export const HatGlasses: IconProps = {
    name: 'HatGlasses',
    children: [
        `<path d="m19 11-.68-6.15a2 2 0 0 0-2.89-1.57L14.02 4a2 2 0 0 1-1.1.2L9 3.8H7.74a2 2 0 0 0-1.98 1.72L5 11M2 11h20" />`,
        `<circle cx="7" cy="18" r="3" />`,
        `<circle cx="17" cy="18" r="3" />`,
        `<path d="M10 18.5c.5-.83 2-2 4 0" />`,
    ]
};